module.exports = __webpack_public_path__ + "static/img/averagejonas.627cfff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/banner/averagejonas.png
// module id = fN7Y
// module chunks = 35